// extracted by mini-css-extract-plugin
export default {"toast":"dHBg8","inner":"VT35B","main":"_hQvW","title":"ep3b7","text":"jgBp4","success":"ROZ5E","error":"f_fJv","info":"Pr11Q"};